import { Card } from '@mui/material';
import { memo } from 'react';
import { selectSelectedTeamMemberId } from 'redux/slices/selectedMemberSlice';
import { useAppSelector } from 'redux/store-hooks';
import SigmaEmbed from './sigmaEmbed';
import { DateTime } from 'luxon';

export const DocketSigmaEmbed = memo(() => {
  const teamMemberId = useAppSelector(selectSelectedTeamMemberId);

  if (!teamMemberId || teamMemberId === 'none') {
    return null;
  }

  return (
    <Card sx={{ flexShrink: 0 }}>
      <SigmaEmbed
        embedKey="docketDashboard"
        embedParams={{
          guideId: teamMemberId,
          yearMonth: DateTime.now().toFormat('yyyyMM'),
        }}
      />
    </Card>
  );
});

DocketSigmaEmbed.displayName = 'DocketSigmaEmbed';
